import PropTypes from 'prop-types';
import MarkdownContent from '@/common/components/MarkdownContent';
import { rehypeArticleImages } from '../utils/article-arcs';

const ArticleArcPreview = ({ record }) => (
  <MarkdownContent rehypePlugins={[[rehypeArticleImages, { images: record?.images }]]}>
    {record?.article}
  </MarkdownContent>
);

ArticleArcPreview.propTypes = {
  record: PropTypes.shape({
    article: PropTypes.string,
    images: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.string]),
  }),
};

ArticleArcPreview.defaultProps = {
  record: undefined,
};

export default ArticleArcPreview;
